var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-col',{staticClass:"pdf-container",style:({ height: _vm.height + ' !important' }),attrs:{"span":24}},[(_vm.loading === false)?_c('iframe',{ref:"pdfIframe",attrs:{"src":_vm.url,"id":"pdf_iframe","width":"100%","height":_vm.height + 'px',"frameborder":"0"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }